import { useRef, useState } from 'react';
import { Trans } from 'next-i18next';
import { usePopper } from 'react-popper';
import { useOutsideClick } from '../../../../../hooks';
import { QuestionMarkTooltip } from '../../../../../icons';
import { LinkPartial } from '../../../../../partials';
import {
  IDmeTooltipArrow,
  IDmeTooltipBubble,
  IDmeTooltipContent,
  IDmeTooltipIcon,
  TooltipContainer,
} from './IDmeTooltip.styles';

export function IDmeTooltip() {
  const containerRef = useRef<HTMLDivElement>(null);
  const buttonRef = useRef<HTMLButtonElement>(null);

  const [isOpen, setIsOpen] = useState(false);
  const [arrowRef, setArrowRef] = useState<HTMLDivElement | null>(null);

  const { styles, attributes } = usePopper(buttonRef.current, containerRef.current, {
    placement: 'bottom-start',
    modifiers: [
      {
        name: 'arrow',
        options: {
          element: arrowRef,
        },
      },
      {
        name: 'flip',
        options: {
          fallbackPlacements: ['bottom-start'],
        },
      },
      {
        name: 'offset',
        options: {
          offset: [-30, 25],
        },
      },
      {
        name: 'preventOverflow',
        options: {
          padding: { left: 5, right: 15 },
        },
      },
    ],
  });

  const handleClick = () => {
    setIsOpen((prevState) => !prevState);
  };

  useOutsideClick(containerRef, () => setIsOpen(false));

  return (
    <TooltipContainer role="tooltip">
      <IDmeTooltipIcon
        onClick={handleClick}
        ref={buttonRef}
        aria-describedby="IDmeTooltip"
        aria-label="More information about ID.me"
        type="button"
      >
        <QuestionMarkTooltip />
      </IDmeTooltipIcon>
      {isOpen && (
        <IDmeTooltipBubble id="IDmeTooltip" ref={containerRef} style={styles.popper} {...attributes.popper}>
          <IDmeTooltipArrow ref={setArrowRef} style={styles.arrow} className="arrow" />
          <IDmeTooltipContent>
            <Trans
              i18nKey="idme.tooltip.message"
              ns="lib-global-common"
              components={{
                IDmeLink: <LinkPartial externalLink="http://id.me/">ID.me</LinkPartial>,
              }}
            />
          </IDmeTooltipContent>
        </IDmeTooltipBubble>
      )}
    </TooltipContainer>
  );
}
